import React, {useContext} from "react";
import {Redirect, Route} from "react-router-dom";
import {AppContext} from "../../context/app/appContext";
import axios from 'axios';

export const PrivateRoute = ({component: Component, ...rest}) => {
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    const appContext = useContext(AppContext);
    // const isAuthenticated = appContext.user.email && appContext.user.accessToken;
    const accessToken = localStorage.getItem('accessToken');
    const isAuthenticated = localStorage.getItem('email') && accessToken
    // const tokenExpiry = await axios(baseURL + '/verify-token', {accessToken})
    // const validToken = tokenExpiry.status === 200 ? true : false

    // axios.post(baseURL + '/verify-token', {accessToken}).then(response => {
    //     console.info({response})
    //     const validToken = response.data.status.message === 'unauthorizedAccess' ? false : true;
    //     return (
    //         <Route {...rest} render={props => !isAuthenticated && !appContext.loading && !validToken ? (<Redirect to='/login'/>) : (<Component {...props} />)}/>
    //     )
    // }).catch(error => {
    //     console.log(error)
    //     return (
    //         <Route {...rest} render={(<Redirect to='/login'/>)}/>
    //     )
    // })

    return (
        <Route {...rest} render={props => !isAuthenticated && !appContext.loading ? (<Redirect to='/login'/>) : (<Component {...props} />)}/>
        // <Route {...rest} render={props => <Component {...props} />}/> /* TODO: for testing */
    )
}
